import React, { useState } from "react";
import AppSwitcherIcon from "../../../../Assets/PaymentsAppHeader/AppSwitcherIcon.svg";
import ZomentumLogo from "../../../../Assets/PaymentsAppHeader/ZomentumLogo.svg";
import GrowIcon from "../../../../Assets/PaymentsAppHeader/GrowIcon.svg";
import PaymentsIcon from "../../../../Assets/PaymentsAppHeader/PaymentsIcon.svg";
import ArrowIcon from "../../../../Assets/PaymentsAppHeader/ArrowIcon.svg";

const PaymentsAppSwitcher: React.FC = () => {
  const [appSwitchPanelOpen, setAppSwitchPanelOpen] = useState<boolean>(false);

  const renderGoTo = (
    href: string,
    imgSrc: string,
    altText: string,
    linkText: string,
    self: boolean = false
  ) => (
    <a
      href={href}
      className="group px-2 py-4 flex justify-between items-center hover:bg-gray-100 cursor-pointer"
      target={self ? "_self" : "_blank"}
      rel="noopener noreferrer"
    >
      <div className="flex items-center">
        <img src={imgSrc} alt={altText} className="w-6 h-6 mx-2" />
        <span className="mx-2 font-semibold">{linkText}</span>
      </div>
      <img
        src={ArrowIcon}
        alt={`Go to ${linkText}`}
        className="w-4 h-4 mx-2 opacity-0 group-hover:opacity-100 group-hover:duration-700 transition-opacity"
      />
    </a>
  );
  return (
    <div>
      <div
        className="flex items-center justify-center h-8 w-8 m-4 cursor-pointer hover:bg-gray-100 rounded"
        onClick={() => setAppSwitchPanelOpen(!appSwitchPanelOpen)}
      >
        <img src={AppSwitcherIcon} alt="Payments App switcher" />
      </div>
      {appSwitchPanelOpen && (
        <div
          className="absolute top-0 left-0 w-screen h-screen z-20 flex flex-row"
          onClick={() => setAppSwitchPanelOpen(false)}
        >
          <div
            className="h-screen w-72 bg-white opacity-100 shadow-2xl"
            onClick={event => event.stopPropagation()}
          >
            <div className="flex justify-between items-center">
              <img
                src={AppSwitcherIcon}
                alt="Payments App switcher"
                className="m-4 p-1 cursor-pointer hover:bg-gray-100 rounded"
                onClick={() => setAppSwitchPanelOpen(false)}
              />
              <img src={ZomentumLogo} alt={ZomentumLogo} className="h-5 mr-16" />
            </div>

            {renderGoTo(
              process.env.REACT_APP_GROW_URL || "https://dashboard.zomentum.com",
              GrowIcon,
              "Zomentum Grow",
              "Grow"
            )}
            {renderGoTo(
              window.location.origin,
              PaymentsIcon,
              "Zomentum Payments",
              "Payments",
              true
            )}
          </div>
          <div className="h-screen flex-grow  bg-gray-600 opacity-30" />
        </div>
      )}
    </div>
  );
};

export default PaymentsAppSwitcher;
